<div class="flex items-center">
  @if(showShortCutButtons()) {
  <p-button icon="pi pi-angle-left" rounded text (onClick)="onChangeDateRangeBy(-1)" />
  }

  <p-date-picker
    #mainDatePicker
    [(ngModel)]="rangeDates"
    selectionMode="range"
    inputId="archived_date_range"
    [readonlyInput]="true"
    [showIcon]="true"
    [firstDayOfWeek]="1"
    [numberOfMonths]="2"
    [showOnFocus]="true"
    [hideOnDateTimeSelect]="false"
    [dateFormat]="'dd.mm.yy'"
    [inputStyleClass]="'font-semibold'"
    [panelStyleClass]="'custom-datepicker-panel'"
    [inputStyle]="{ width: '200px' }"
    (ngModelChange)="onChange($event)"
  >
    <ng-template pTemplate="header">
      <div class="custom-datepicker-header">
        <div class="date-range-list">
          <div
            *ngFor="let range of dateRanges"
            [class.selected]="selectedDateRange() === range.value"
            class="date-range-item"
            (click)="setDateRange(range.value)"
          >
            {{ range.label }}
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="custom-datepicker-footer flex justify-between mt-3">
        <div class="pt-2">&nbsp;</div>
        <div>
          <p-button label="Cancel" outlined class="mr-2" severity="secondary" (click)="cancel()" />
        </div>
      </div>
    </ng-template>
  </p-date-picker>

  @if(showShortCutButtons()) {
  <p-button icon="pi pi-angle-right" rounded text (onClick)="onChangeDateRangeBy(1)" />
  }
</div>
